import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  TextField as MuiTextField,
  MenuItem as MuiMenuItem,
  Toolbar as MuiToolbar,
  Typography as MuiTypography,
} from "@mui/material";
import { Language as MuiLanguageIcon } from "@mui/icons-material";
import axios from "axios";
import { useFormik } from "formik";
import {
  StudyWebsiteListingStatus,
  GET_STUDIES_URL_BASE,
} from "app/shared/constants";
import LoadingIndicator from "./LoadingIndicator";

const PageTitleListingStatus = (props) => {
  const {
    studyId,
    protocolNumber,
    studyListingStatus,
    isPublishable,
    onStatusUpdated,
  } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      studyListingStatus: studyListingStatus,
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const apiHeader = {
          headers: {
            "Content-Type": "application/merge-patch+json",
          },
        };
        const studyData = {
          studyListingStatus: values.studyListingStatus,
        };
        const response = await axios.patch(
          GET_STUDIES_URL_BASE + "/study-website-content/" + studyId,
          studyData,
          apiHeader,
        );
        if (response?.data) {
          setError(false);
          const updatedStatus = response.data.studyListingStatus;
          resetForm({
            values: {
              ...values,
              studyListingStatus: response?.data.studyListingStatus,
            },
          });
          onStatusUpdated(updatedStatus);
        }
      } catch (err) {
        setError(true);
        //setError(t("StudyWebisteContentForm.failedToUpdateStudyStatus"));
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <MuiToolbar
      sx={{
        width: "100%",
        minHeight: "30px",
        paddingTop: "24px",
      }}
    >
      <MuiTypography
        fontSize="22.5px"
        fontWeight={500}
        noWrap
        sx={{ paddingTop: "10px" }}
        component="div"
      >
        <MuiLanguageIcon sx={{ marginBottom: "-5px" }} /> `{protocolNumber}`
        Clinical Trials Directory Listing
        {"\u00a0".repeat(3)}
        <MuiTextField
          select
          name="studyListingStatus"
          label={t(`StudyWebisteContentForm.studyListingStatus`)}
          size="small"
          value={formik.values.studyListingStatus || ""}
          onChange={(e) => {
            const value = e.target.value;
            formik.setFieldValue("studyListingStatus", value);
            formik.submitForm();
          }}
          disabled={loading || !isPublishable}
          //helperText={!isPublishable && "This element is disabled until your protocol is open to accrual"}
          error={Boolean(error)}
          sx={{
            width: 180,
            marginTop: "-5px",
            "& .MuiInputBase-input": {
              fontSize: "22.5px",
            },
          }}
        >
          {StudyWebsiteListingStatus?.map((item) => (
            <MuiMenuItem key={item} value={item}>
              {t("studyListingStatus." + item)}
            </MuiMenuItem>
          ))}
        </MuiTextField>
        {loading && <LoadingIndicator />}
      </MuiTypography>
    </MuiToolbar>
  );
};

PageTitleListingStatus.propTypes = {
  protocolNumber: PropTypes.string,
  studyListingStatus: PropTypes.string.isRequired,
  studyId: PropTypes.number.isRequired,
  isPublishable: PropTypes.bool.isRequired,
  onStatusUpdated: PropTypes.func.isRequired,
};

export default PageTitleListingStatus;
